import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { WalletService } from '../services/wallet.service';
import { Ng2SmartTableModule, LocalDataSource } from 'ng2-smart-table';
import { NbDialogRef } from '@nebular/theme';




@Component({
  selector: 'ngx-user-transactions-dialog',
  templateUrl: './user-transactions-dialog.component.html',
  styleUrls: ['./user-transactions-dialog.component.scss']
})
export class UserTransactionsDialogComponent implements OnInit {

  constructor(private _aS: ApiService,
    private _walletService: WalletService,
    private dialogRef: NbDialogRef<UserTransactionsDialogComponent>) { }
  

  isMetamask: boolean;  
  walletAddress: any;
  isConnected: boolean;
  currentUserAddress: any;
  walletName: any;
  customerTransactions: any;
  
  
  
  source: LocalDataSource = new LocalDataSource();
  settings = {
    mode: "external",
    hideSubHeader: true,
    reset: true,

    actions: {
      custom: [],
      edit: false,
      delete: false,
      add: false,
    },
    // Properties of smart table
    columns: {
      txHash: {
        title: "Hash",
        type: "string",
        filter: true,
        },

      amount: {
        title: "Amount",
        type: "string",
        filter: false,
      },
      statusOfTx: {
        title: "Status",
        type: "number",
        noDataMessage: "No data to display!",
        filter: false,
      },

      createdAt: {
        title: "Created at",
        type: "date",
        sort: true,
        sortDirection: "dsc",
        filter: false,

        valuePrepareFunction: (createdAt) => {
          return (
            new Date(createdAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }) +
            " " +
            new Date(createdAt).toLocaleTimeString("en-US", {
              hour12: false,
            })
          );
        }
      },
        updatedAt: {
          title: "Created at",
          type: "date",
          sort: true,
          sortDirection: "dsc",
          filter: false,
  
          valuePrepareFunction: (createdAt) => {
            return (
              new Date(createdAt).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              }) +
              " " +
              new Date(createdAt).toLocaleTimeString("en-US", {
                hour12: false,
              })
            );
          },
      },
    }
  };
  
  
  
  
  ngOnInit() {
    this.checkWallet();
    this.getCurrentUserAddress();

  }



  checkWallet = async () => {
    this.isConnected = await this._walletService.checkWalletConnection();
    if (this.isConnected) {
        // this.walletName = (await this.getCurrentUserAddress()).substring(0, 10) +"...";
        this.walletAddress = await this.getCurrentUserAddress();
        this.walletName = (await this.getCurrentUserAddress());
        this.isMetamask = true;
        console.log(this.walletName)
        this._aS.getTransactionByAddress(this.walletAddress).subscribe((res) =>{
          console.log(res)
          this.customerTransactions = res;
          this.source.load(this.customerTransactions)
        })
      return true;

    } else {
        if (
            (await this._walletService.getCryptoComAddress()) != undefined
        ) {
            this.currentUserAddress =
                await this._walletService.getCryptoComAddress();
            this.isConnected = true;
            this.isMetamask = false;
            
        }
    }
};
getCurrentUserAddress = async () => {
    if ((await this._walletService.getAddress()) === undefined) {
        return await this._walletService.getCryptoComAddress();
    } else {
        return await this._walletService.getAddress();
    }
};
  onClose() {
    this.dialogRef.close();
  }

  }



